// extracted by mini-css-extract-plugin
export default {"card":"StickerCard_card__AP2g8","colored":"StickerCard_colored__TMg2i"};